module.exports = __webpack_public_path__ + "static/media/Spark_Radius.02bb1457.xls";